
/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */
 import  React, { Component }  from "react"
 import Header from "./header"
 import Footer from "./footer"
 import "./layout.css"
 class Layout extends Component{
   constructor(props) {
     super(props);
     this.state = {
     }
   }



   addScript(url){
     const script = document.createElement("script")
     script.src = url
     script.async = false
     document.body.appendChild(script)
   }

     componentDidMount(){
         /*this.addScriptGoogle(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
         new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
         j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
         'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
         })(window,document,'script','dataLayer','GTM-593CQ9M');
         `);*/

         this.addScript("/customjs/jquery-3.6.0.min.js");
         this.addScript("/customjs/mobile.js");
	 this.addScript("/customjs/getbillage_custom.js");

     }

   removeScript(scriptToremove){
       let allsuspects=document.getElementsByTagName("script");
       for (let i=allsuspects.length; i>=0; i--){
         if (allsuspects[i] && allsuspects[i].getAttribute("src")!==null
           && allsuspects[i].getAttribute("src").indexOf(`${scriptToremove}`) !== -1 ){
                    allsuspects[i].parentNode.removeChild(allsuspects[i])
           }
       }
   }

   componentWillUnmount() {
       this.removeScript("/customjs/jquery-3.6.0.min.js");
       this.removeScript("/customjs/mobile.js");
	this.removeScript("/customjs/getbillage_custom.js");

     }

   render(){
       // const data = useStaticQuery(graphql`
       //   query SiteTitleQuery {
       //     site {
       //       siteMetadata {
       //         title
       //       }
       //     }
       //   }
       // `)

       return <div>
             {/*}<div dangerouslySetInnerHTML={{__html: `
             <!-- Google Tag Manager (noscript) -->
             <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TTXBSX"
             height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
             <!-- End Google Tag Manager (noscript) -->`}}/>*/}
           {/*<div dangerouslySetInnerHTML={{__html:`<script src="https://consent.cookiefirst.com/banner.js" data-cookiefirst-key="74dd1ff3-b95f-4668-9f87-e3084d5b47c8"></script>`}}/>*/}
           <div dangerouslySetInnerHTML={{__html:`<script>
              function getUrlVars() {
                                          var vars = {};
                                          var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
                                                          vars[key] = value;
                                          });
                                          return vars;
                            }

                            var idReseller = getUrlVars()["idReseller"];
                            if(idReseller){

                                          var d = new Date();
                                          d.setTime(d.getTime()+(90*24*60*60*1000));
                                          var expires = "expires="+d.toGMTString();
                                          document.cookie = "idReseller=" + idReseller + "; " + expires + ";domain=getbillage.com; path=/";
                            }

                            var referrer = document.referrer;
                            if(referrer){

                                          if (document.cookie.indexOf("es.billage.referrer") == -1){
                                                          var d = new Date();
                                                          d.setTime(d.getTime()+(90*24*60*60*1000));
                                                          var expires = "expires="+d.toGMTString();
                                                          document.cookie = "com.getbillage.referrer=" + referrer + "; " + expires + ";domain=getbillage.com; path=/";
                                          }
                            }


                            var utmsource = getUrlVars()["utm_source"];

                            if(utmsource){
                                          var d = new Date();
                                          d.setTime(d.getTime()+(90*24*60*60*1000));
                                          var expires = "expires="+d.toGMTString();
                                          document.cookie = "com.getbillage.utmsource=" + utmsource + "; " + expires + ";domain=getbillage.com; path=/";
                            }


                            var utmmedium = getUrlVars()["utm_medium"];
                            if(utmmedium){
                                          var d = new Date();
                                          d.setTime(d.getTime()+(90*24*60*60*1000));
                                          var expires = "expires="+d.toGMTString();
                                          document.cookie = "com.getbillage.utmmedium=" + utmmedium + "; " + expires + ";domain=getbillage.com; path=/";
                            }


                            var utmcampaign = getUrlVars()["utm_campaign"];
                            if(utmcampaign){

                                          var d = new Date();
                                          d.setTime(d.getTime()+(90*24*60*60*1000));
                                          var expires = "expires="+d.toGMTString();
                                          document.cookie = "com.getbillage.utmcampaign=" + utmcampaign + "; " + expires + ";domain=getbillage.com; path=/";
                            }


                            var utmterm = getUrlVars()["utm_term"];
                            if(utmterm){

                                          var d = new Date();
                                          d.setTime(d.getTime()+(90*24*60*60*1000));
                                          var expires = "expires="+d.toGMTString();
                                          document.cookie = "com.getbillage.utmterm=" + utmterm + "; " + expires + ";domain=getbillage.com; path=/";
                            }
            </script>`}}/>
           <Header idPage={this.props.idPage} langPage={this.props.langPage} clase_pagina={this.props.clase_pagina}/>
           <div id={this.props.id_pagina} className={this.props.clase_pagina}>


             <main>
               <div	className="contingut">
               {this.props.children}
               </div>
             </main>

             <Footer  langPage={this.props.langPage} />
           </div>
         </div>;
     }

 }

 export default Layout
